const DEFAULT_EXTRA_OFFSET = 16;

function resolveScrollBehavior() {
  if (typeof window === 'undefined') {
    return 'auto';
  }

  const prefersReducedMotion =
    window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;

  return prefersReducedMotion ? 'auto' : 'smooth';
}

function syncHash(hash) {
  if (typeof window === 'undefined') {
    return;
  }

  const normalizedHash = hash.startsWith('#') ? hash : `#${hash}`;
  const nextUrl = `${window.location.pathname}${window.location.search}${normalizedHash}`;

  if (window.location.hash === normalizedHash) {
    window.history.replaceState(null, '', nextUrl);
    return;
  }

  window.history.pushState(null, '', nextUrl);
}

export function scrollToHash(hash, options = {}) {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  const targetId = decodeURIComponent(String(hash ?? '').replace(/^#/, '').trim());

  if (!targetId) {
    window.scrollTo({ top: 0, behavior: resolveScrollBehavior() });
    return true;
  }

  const targetElement = document.getElementById(targetId);

  if (!targetElement) {
    return false;
  }

  const headerElement = options.headerSelector
    ? document.querySelector(options.headerSelector)
    : null;
  const headerOffset = headerElement?.getBoundingClientRect().height ?? 0;
  const extraOffset = options.extraOffset ?? DEFAULT_EXTRA_OFFSET;
  const top = Math.max(
    0,
    window.scrollY + targetElement.getBoundingClientRect().top - headerOffset - extraOffset
  );

  if (options.updateHash !== false) {
    syncHash(`#${targetId}`);
  }

  window.scrollTo({
    top,
    behavior: options.behavior ?? resolveScrollBehavior()
  });

  return true;
}
